import { naturalSortBy, unique } from 'utils/list'

/**
 * Handles addition of multiple tag values one at a time or comma-separated
 */
export function splitInputIntoMultipleValues(
  currentInput: string | string[]
): string[] {
  if (typeof currentInput === 'string') {
    return currentInput
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean)
  }

  return naturalSortBy(
    unique(currentInput.flatMap((value) => splitInputIntoMultipleValues(value)))
  )
}
